import React from 'react';
import classNames from 'classnames';

import { ITableColumn } from '../../../types/commonTypes';

import css from './style.module.scss';

interface IProps {
  columns: ITableColumn<any>[];
  data: {
    [key: string]: any;
  }[];
  mapKey: string;
  onRowClick: (props: any) => void;
}

const Table = ({ mapKey, data, columns, onRowClick }: IProps) => {
  return (
    <table className={css.table}>
      <thead>
        <tr className={css.table__row}>
          {columns.map(({ name, key, width }) => (
            <th style={{ width }} className={css.table__head} key={key}>
              {name}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {data.map((props: any) => (
          <tr onClick={() => onRowClick(props)} className={css.table__row} key={props[mapKey]}>
            {columns.map(({ cell, key, textColor, width }) => (
              <td
                className={classNames(css.table__cell, {
                  [css[`table__cell_textColor_${textColor}`]]: textColor,
                })}
                style={{ width }}
                key={key}
              >
                {cell(props)}
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default Table;
